export default __webpack_public_path__ + "static/alfred_homepage-e9d4cf8546ef49a0e1c09d5a95f603c6.png";